/*
 * VAIROK · Ofertas del cajón y de la página /cart (sustituyen a Candy Rack). Sin dependencias.
 *   - «Zweites Licht»: segunda VK-Q5 (data-key = key de la línea, data-qty = 2).
 *   - Clip óptico de la gafa GT/RS/ST (data-key = id de la variante del clip, data-qty = 1).
 *
 * El cajón se vuelve a pintar entero (CartDrawer.refresh sustituye el innerHTML de <cart-drawer>),
 * y en /cart la sección main-cart (ThemeCart.refresh), así que todo va por delegación en document
 * y no guarda referencias a nodos.
 *
 * Clic en [data-vk-add-second]:
 *   POST /cart/update.js con {updates: {<key>: <qty>}, attributes: {<data-upsell-key>: <data-upsell>}}.
 *   Con la key de línea cambia la cantidad (la luz no sale en dos líneas); con un id de variante que
 *   no está en el carrito, Shopify la añade. El atributo sirve para medir: por defecto
 *   _vairok_upsell = cajon_luz; el clip usa _vairok_upsell_clip = cajon_clip_gt|rs|st.
 *   Bien  -> 'cart:item-added' (eventos estándar del tema) y 'cart:refresh'.
 *   Error -> mensaje bajo la oferta y 'cart:refresh'. NUNCA se reintenta: un 422 puede haber
 *            añadido una parte.
 */
(function () {
  'use strict';

  if (window.__vkCartBound) return;
  window.__vkCartBound = true;

  var pendingErrorKey = null;

  function updateUrl() {
    var routes = window.theme && window.theme.routes;
    if (routes && routes.cart_update_url) return routes.cart_update_url + '.js';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // La misma oferta puede estar en el cajón y en la página /cart: el error sale en las dos.
  function showError(key) {
    var buttons = document.querySelectorAll('[data-vk-add-second]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-key') !== key) continue;
      var offer = buttons[i].closest('[data-vk-offer]');
      var msg = offer && offer.querySelector('[data-vk-offer-error]');
      if (msg) msg.hidden = false;
    }
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-vk-add-second]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var key = button.getAttribute('data-key');
    var qty = parseInt(button.getAttribute('data-qty'), 10) || 2;
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10) || null;
    var attrKey = button.getAttribute('data-upsell-key') || '_vairok_upsell';
    var attrValue = button.getAttribute('data-upsell') || 'cajon_luz';
    if (!key) return;

    var offer = button.closest('[data-vk-offer]');
    var oldMsg = offer && offer.querySelector('[data-vk-offer-error]');
    if (oldMsg) oldMsg.hidden = true;
    pendingErrorKey = null;
    setBusy(button, true);

    var updates = {};
    updates[key] = qty;
    var attributes = {};
    attributes[attrKey] = attrValue;

    fetch(updateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, attributes: attributes })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) throw new Error('vk-cart: update failed');
        // Eventos estándar del tema (assets/app.js): cuenta como una unidad añadida.
        if (variantId) {
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { product: { id: variantId, variant_id: variantId, quantity: 1 } }
          }));
        }
        refreshDrawer();
      })
      .catch(function () {
        // Sin reintento. El mensaje se enseña ya y otra vez cuando el cajón se haya vuelto a pintar.
        pendingErrorKey = key;
        showError(key);
        refreshDrawer();
        // En /cart la sección de la página se repinta por su cuenta y puede llegar después del cajón.
        window.setTimeout(function () { showError(key); }, 2500);
      });

    // Por si el refresco no llega a pintar el cajón (sin red), el botón no se queda bloqueado.
    window.setTimeout(function () {
      if (document.contains(button) && button.getAttribute('aria-busy') === 'true') {
        setBusy(button, false);
      }
    }, 8000);
  });

  // CartDrawer.refresh() lanza 'line-item:change:end' cuando ha sustituido el HTML del cajón.
  document.addEventListener('line-item:change:end', function () {
    if (!pendingErrorKey) return;
    showError(pendingErrorKey);
    pendingErrorKey = null;
  });
})();

/*
 * VAIROK · Guardia de las Random Lens (Marc, 04/10/2026): «la random lens solo la puedes tener si compras una gafa».
 *   - Random GT Lens (variante 48407276880205): solo con gafas GT y como mucho una por gafa GT. Sin gafas GT se
 *     quita, la haya puesto la casilla de la ficha o el cliente a mano, con o sin código. Las RS o ST no cuentan.
 *   - Random RS Lens (48630971007309): igual, solo con gafas RS.
 *   - Códigos «Compra X y llévate Y» (desde la auditoría del 04/10): GT VK-GT-GLAS-JUPS99, RS VK-RS-GLAS-FG3MP1,
 *     SW VK-SW-NEBEL-C8TAX6. Sin gafas de la familia, fuera su código (las lentes Fog se quedan, a precio normal).
 *     Los antiguos (VAIROK-GT-LENS-IUGINQ, VAIROK-RS-LENS-QQQNSW, VAIROK-SW-FOG30-KH84AR) se quitan siempre; si
 *     hay gafa de la familia, se cambian por el nuevo. Los demás códigos se conservan.
 *   - El resto de lentes (de colores, Fog, clips) no se toca.
 *   Al recortar, se quitan primero las lentes añadidas a mano y se deja la de la casilla (_vairok_offer).
 * La familia de cada línea la da el tema (<script data-vk-cart-fam> de snippets/vk-cart-shipbar.liquid: plantilla
 * vairok-gt* / vairok-rs* / vairok-sw* o colección). Una key de línea siempre es el mismo producto, así que vale
 * cualquier mapa que tenga todas las keys del carrito; si ninguno las tiene, se pide la sección cart-drawer, y si
 * aun así no, no se toca nada.
 * Cuándo: al terminar un cambio de cantidad (cajón o /cart, con el carrito que trae el propio evento), al abrirse
 * el cajón (después de añadir) y al cargar la página si hay carrito.
 * Una sola llamada /cart/update.js (updates + discount + secciones): el cajón, el contador y /cart se pintan con
 * su respuesta, sin otra recarga. La primera vez en la sesión, aviso corto arriba del cajón: sin gafa, «Das
 * Ersatzglas gibt es nur zusammen mit einer VAIROK GT»; con gafa y lentes de más, «Pro VAIROK GT gibt es ein
 * Ersatzglas gratis». Textos en #VkCartMsgs (snippets/cart-drawer.liquid).
 * Freno anti-bucle: la misma corrección sobre el mismo carrito no se repite antes de 20 s, salvo que el cliente
 * haya hecho algo entretanto (cambio de cantidad, cajón abierto, artículo añadido), que lo reinicia.
 */
(function () {
  'use strict';

  if (window.__vkCartGuard) return;
  window.__vkCartGuard = true;

  var RULES = [
    { fam: 'gt', code: 'VK-GT-GLAS-JUPS99', old: ['VAIROK-GT-LENS-IUGINQ'], variant: 48407276880205, product: 8908852265293 },
    { fam: 'rs', code: 'VK-RS-GLAS-FG3MP1', old: ['VAIROK-RS-LENS-QQQNSW'], variant: 48630971007309, product: 8955407499597 },
    { fam: 'sw', code: 'VK-SW-NEBEL-C8TAX6', old: ['VAIROK-SW-FOG30-KH84AR'] }
  ];
  var LENS_PRODUCTS = [8908852265293, 8955407499597];

  var inFlight = 0;
  var startAt = 0;
  var running = false;
  var timer = null;
  var lastSig = '';
  var lastAt = 0;
  var eventCart = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function up(s) { return String(s || '').toUpperCase(); }

  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function parseMap(node) {
    try { return (JSON.parse(node.textContent) || {}).lines || null; } catch (e) { return null; }
  }
  function covers(map, cart) {
    if (!map) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(map, cart.items[i].key)) return false;
    }
    return true;
  }
  function mapFor(cart) {
    if (!cart.items.length) return Promise.resolve({});
    var nodes = document.querySelectorAll('script[data-vk-cart-fam]');
    for (var i = nodes.length - 1; i >= 0; i--) {
      var m = parseMap(nodes[i]);
      if (covers(m, cart)) return Promise.resolve(m);
    }
    return fetch(window.location.pathname + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['cart-drawer'] || '', 'text/html');
        var node = doc.querySelector('script[data-vk-cart-fam]');
        var m = node && parseMap(node);
        return covers(m, cart) ? m : null;
      })
      .catch(function () { return null; });
  }

  function isOffer(item) {
    return !!(item.properties && item.properties._vairok_offer);
  }

  function plan(cart, map) {
    var count = {};
    cart.items.forEach(function (item) {
      if (LENS_PRODUCTS.indexOf(item.product_id) !== -1) return; // una lente nunca cuenta como gafa
      var fam = map[item.key];
      if (fam) count[fam] = (count[fam] || 0) + item.quantity;
    });
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
    var codesUp = codes.map(up);
    var updates = {};
    var drop = [];
    var add = [];
    var notes = [];

    RULES.forEach(function (rule) {
      var allowed = count[rule.fam] || 0;
      if (rule.variant) {
        var lines = cart.items.filter(function (item) {
          return item.variant_id === rule.variant || item.product_id === rule.product;
        });
        var excess = lines.reduce(function (n, item) { return n + item.quantity; }, 0) - allowed;
        if (excess > 0) {
          var order = lines.filter(function (i) { return !isOffer(i); }).reverse().concat(lines.filter(isOffer).reverse());
          for (var k = 0; k < order.length && excess > 0; k++) {
            var cut = Math.min(order[k].quantity, excess);
            updates[order[k].key] = order[k].quantity - cut;
            excess -= cut;
          }
          notes.push(rule.fam + (allowed > 0 ? '_cap' : ''));
        }
      }
      var hasOld = rule.old.some(function (c) { return codesUp.indexOf(c) !== -1; });
      if (hasOld) Array.prototype.push.apply(drop, rule.old);
      if (allowed === 0 && codesUp.indexOf(rule.code) !== -1) drop.push(rule.code);
      if (allowed > 0 && hasOld && codesUp.indexOf(rule.code) === -1) add.push(rule.code);
    });

    if (!Object.keys(updates).length && !drop.length && !add.length) return null;
    var body = {};
    if (Object.keys(updates).length) body.updates = updates;
    if (drop.length || add.length) {
      body.discount = codes.filter(function (c) { return drop.indexOf(up(c)) === -1; }).concat(add).join(',');
    }
    return { body: body, notes: notes };
  }

  // Aviso, una vez por sesión y familia.
  function noteFor(fams) {
    var msgs = {};
    try { msgs = JSON.parse((document.getElementById('VkCartMsgs') || {}).textContent || '{}'); } catch (e) { msgs = {}; }
    var out = [];
    fams.forEach(function (fam) {
      var seen = false;
      try { seen = window.sessionStorage.getItem('vk_lens_note_' + fam) === '1'; } catch (e) { seen = false; }
      if (seen || !msgs[fam]) return;
      try { window.sessionStorage.setItem('vk_lens_note_' + fam, '1'); } catch (e) { /* sin almacenamiento */ }
      out.push(msgs[fam]);
    });
    if (!out.length) return null;
    var p = document.createElement('p');
    p.className = 'vk-cart-note';
    p.setAttribute('role', 'status');
    out.forEach(function (text, i) {
      if (i) p.appendChild(document.createElement('br'));
      p.appendChild(document.createTextNode(text));
    });
    return p;
  }

  function inner(html, selector, note, where) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    if (!el) return null;
    if (note && where) {
      var spot = el.querySelector(where.join(','));
      if (spot) {
        var n = doc.importNode(note, true);
        if (spot.matches('h4')) spot.parentNode.insertBefore(n, spot.nextSibling);
        else spot.insertBefore(n, spot.firstChild);
      }
    }
    return el.innerHTML;
  }

  function render(data, note) {
    var sections = data && data.sections;
    if (!sections || !sections['cart-drawer']) return false;
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      var html = inner(sections['cart-drawer'], '.cart-drawer', note, ['.side-panel-content']);
      if (html !== null) drawer.innerHTML = html;
    }
    var bubble = document.getElementById('cart-drawer-toggle');
    var bubbleTarget = bubble && (bubble.querySelector('.thb-item-count') || bubble);
    if (bubbleTarget && sections['cart-bubble']) {
      var b = inner(sections['cart-bubble'], '.thb-item-count');
      if (b !== null) bubbleTarget.innerHTML = b;
    }
    var page = document.getElementById('Cart');
    if (page && sections['main-cart']) {
      var m = inner(sections['main-cart'], '.thb-cart-form', note, ['#cart-form > h4', '.cart-empty']);
      if (m !== null) page.innerHTML = m;
    }
    return true;
  }

  function apply(result, cart) {
    // Nunca en bucle: la misma corrección sobre el mismo carrito no se repite antes de 20 s. Cualquier acción del
    // cliente (cambio de cantidad, cajón abierto, artículo añadido) borra lastSig: ver los escuchadores de abajo.
    var state = cart.items.map(function (i) { return i.key + '=' + i.quantity; }).join('|') + '#' +
      (cart.discount_codes || []).map(function (d) { return d.code; }).join(',');
    var sig = state + '>' + JSON.stringify(result.body);
    if (sig === lastSig && Date.now() - lastAt < 20000) return null;
    lastSig = sig;
    lastAt = Date.now();
    var body = result.body;
    body.sections = ['cart-drawer', 'cart-bubble'];
    if (document.getElementById('Cart')) body.sections.push('main-cart');
    body.sections_url = window.location.pathname;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var note = result.notes.length ? noteFor(result.notes) : null;
        if (!render(data, note)) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        // Mismo evento que el tema al terminar un cambio (píxeles, eventos estándar). Vuelve a pasar por aquí y
        // ya no encuentra nada que corregir.
        document.dispatchEvent(new CustomEvent('line-item:change:end', { detail: { quantity: 0, cart: data } }));
      });
  }

  function run() {
    timer = null;
    // Un cambio que falló sin avisar no puede dejar la guardia parada para siempre.
    if (inFlight > 0 && Date.now() - startAt > 10000) inFlight = 0;
    if (running || inFlight > 0) return;
    running = true;
    var cart0;
    var fromEvent = eventCart;
    eventCart = null;
    (fromEvent ? Promise.resolve(fromEvent) : getCart())
      .then(function (cart) { cart0 = cart; return mapFor(cart); })
      .then(function (map) {
        if (!map) return null;
        var result = plan(cart0, map);
        return result ? apply(result, cart0) : null;
      })
      .catch(function (e) { console.error('vk-cart guard', e); })
      .then(function () { running = false; });
  }

  function schedule(delay) {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(run, delay);
  }

  function customerActed() { lastSig = ''; }
  document.addEventListener('line-item:change:start', function () { inFlight++; startAt = Date.now(); customerActed(); });
  document.addEventListener('cart:item-added', customerActed);
  document.addEventListener('line-item:change:end', function (e) {
    inFlight = Math.max(0, inFlight - 1);
    var c = e.detail && e.detail.cart;
    eventCart = (c && c.token && c.items && c.discount_codes) ? c : null;
    schedule(eventCart ? 0 : 150);
  });
  document.addEventListener('cart-drawer:open', function () { customerActed(); eventCart = null; schedule(300); });

  // Al cargar: solo si hay carrito (el mapa solo se pinta con artículos).
  if (document.querySelector('script[data-vk-cart-fam]')) schedule(500);
})();
